export class Message {
    public constructor(
        public sender?: string,
        public message?: any
    ) {}
    
}